/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ included: NonNullable<unknown>, used: NonNullable<unknown>, overage: NonNullable<unknown> }} Receipt_Usage_Explained_PlainInputs */



/**
* | output |
* | --- |
* | "{included} included credit · {used} used · {overage} overage" |
*
* @param {Receipt_Usage_Explained_PlainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_usage_explained_plain = /** @type {((inputs: Receipt_Usage_Explained_PlainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Usage_Explained_PlainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.included} Guthaben enthalten · ${i?.used} genutzt · ${i?.overage} Überschreitung`)
	return /** @type {LocalizedString} */ (`${i?.included} included credit · ${i?.used} used · ${i?.overage} overage`)
});